import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { ProductViewModel } from '~/lib/data-contract';
import { fetchProduct } from '~/lib/fetchProduct';
import { useFranchise } from '~/shared/utils';

export type UseProductProps = {
    productId?: string;
    productColorId?: string;
};

export const useProduct = (props?: UseProductProps | null, alwaysUseProps = false) => {
    const { queryKey, franchiseAPIPath } = useFranchise();
    const router = useRouter();

    // Determine productId and productColorId based on alwaysUseProps flag
    const { productId = '', productColorId = '' } = props || alwaysUseProps
        ? props || { productId: '', productColorId: '' }
        : {
              productId: (router.query.productId as string) || '',
              productColorId: (router.query.variantId as string) || '',
          };

    const productQueryKey = ['product', { queryKey, productId, productColorId }];

    return useQuery<ProductViewModel, Error>(
        productQueryKey,
        () => fetchProduct({ productId, productColorId, franchiseAPIPath }),
        {
            enabled: Boolean(productId && productColorId),
            retry: false,
        }
    );
};
